import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { MyHttpService } from '../../../../../services/myHttp/my-http.service';
import { IdCardRequest } from '../../models/id-card-info';
import { ServiceResult } from '../../../../../base-classes/service-result';
import { AppSettings } from '../../../../../utils/app-settings';

@Injectable({
  providedIn: 'root'
})
export class IdCardService {

  constructor(private injector: Injector) { }

  private getMyHttp(): MyHttpService {
    return this.injector.get(MyHttpService);
  }

  getIdCardStatus(): Observable<ServiceResult<IdCardRequest>> {
    let url = AppSettings.apiUrl + "idcard/status";

    return this.getMyHttp().doHttp<IdCardRequest, IdCardRequest>(
      url,
      x => x
    );
  }

  apply(): Observable<ServiceResult<IdCardRequest>> {
    let url = AppSettings.apiUrl + "idcard/apply";
    return this.getMyHttp().doHttpSafePost<any, IdCardRequest>(url, null, x => x);
  }

}
